import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { latLng, tileLayer } from "leaflet";
import { DataService } from "src/app/shared/Services/data.service";
import { HttpClient } from "@angular/common/http";
import { ShareService } from "src/app/shared/Services/shared.service";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { ChartType } from "../moreInfo/echart/echart.model";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";

@Component({
  selector: "app-machine-data-info",
  templateUrl: "./machine-data-info.component.html",
  styleUrls: ["./machine-data-info.component.scss"],
})

export class MachineDataInfoComponent implements OnInit, AfterViewInit,OnDestroy {
  donughnutChart: ChartType;
  private destroy$: Subject<void> = new Subject<void>();
  custName: any;
  shift_Time;
  isCollapsed = true;
  userName: any = "";
  role: any;
  device_bar_chart: any;
  currentStatus: string;
  isReactivePower: boolean = false;
  reactive_power: any;
  trendChart: any = [];
  current;
  LUT;
  status;
  m_effic;
  parts;
  combinedData;
  availability;
  quality;
  perf;
  totalPartCount: any = 0;
  pieStatus:any=[];
  r_power;
  a_power;
  energy;
  t_energy;
  showPieChart: boolean = false;
  finalcombinedData: any = [];
  selectedDateOption: string = "Live";
  historycombinedData: any = [];
  count: any;
  previousDays: any = [];
  typeData: any;
  showChart: boolean = false;
  showChart1: boolean = false;
  pie_response: any;
  clustr_Chart: boolean = false;
  cluster_data:any = [];
  showGantt: boolean = false;
  selectedCars = "All Shift";
  breadCrumbItems: Array<{}>;
  powerUnitCost:any;
  options = {
    layers: [
      tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 18,
        attribution: "...",
      }),
    ],
    zoom: 6,
    center: latLng(46.879966, -121.726909),
  };
  deviceName;
  apiInterval: any;
  currentShift:any;
  allShift = [];
  params: any;
  intervalFlag: boolean = true;
  deviceType;
  prodLoss: any;
  energycost: any;
  showHourchart: boolean = false;
  hourlyData: any;
  trendData: any = "current";
  outLine: boolean = false;
  timeLine: boolean = true;
  partDetails: boolean = false;
  selectedTab: string = "TimeLines";
  showCombined: boolean = false;
  historydata: boolean = false;
  historyDatas = [];
  currentDay = [];
  yesterDay =[];
  previousyesterDay=[]
  ganttData: any;
  isLineChart: boolean = true;
  timeZone: any;
  totalHourlyPartCount:any;
  operatorName:any;
  partName:any;
  liveBool:boolean = false;

  constructor(
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private getcurrentShift : GetCurrentShift
  ) {
    var user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custName = user["user"];
    this.role = this.custName.role;
    this.userName = sessionStorage.getItem("Selected_CustomerName");
    this.shift_Time = this.custName["currentShift"];
  }
  today:any;
  today2:any;
  proviousDay:any;
  proviousDay2:any;
  ngOnInit() {
    var user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custName = user["user"];
    this.timeZone= user["user"]["timeZone"] || sessionStorage.getItem("Selected_CustomerTimeZone") ;
    this.role = this.custName.role;
    this.userName = sessionStorage.getItem("Selected_CustomerName");
    this.shift_Time = this.custName["currentShift"];
    var shared_data = JSON.parse(sessionStorage.getItem("machineInfio"));
    this.params = shared_data;
    var shift = JSON.parse(sessionStorage.getItem("shiftInfio"));
    this.allShift = shift["shift"];
    this.currentShift =this.getcurrentShift.getCurrentShift(shift['shift'],this.timeZone)
    console.log(this.currentShift,"currentShift")
    this.today= `Today-(${this.currentShift['shiftName']})`
    this.today2 = "Today - Total Duration"
    this.proviousDay= "Yesterday"
    this.proviousDay2= "Day Before Yesterday,"
    this.selectedCars = this.currentShift["shiftName"];
    this.params.shiftName = this.currentShift?.usershiftId;//||this.currentShift?.shiftId;//"all";
    // var shiftName = this.getCurrentShift(shift["shift"]);
    this.deviceName = this.params.deviceName;
    this.deviceType = this.params.deviceType;
    delete this.params.deviceName;
    this.breadCrumbItems = [
      { label: this.userName ? this.userName : "K2" },
      { label: "Machine_Info", active: true },
    ];
    this.spinner.show();
    console.log(this.params)
    this.getCustData(this.params);
    // this.lossCount(this.params);
    // this.gattchart(this.params);
    this.getPartCount(this.params);

    this.devicebarchart(this.params);
    // this.tempTrend(this.params);
    this.hourlyPart(this.params);
    // this.scatterChart();
    if(this.apiInterval)clearTimeout(this.apiInterval)
      var newparam = {
        custID: this.params["custID"],
        deviceID: this.params["deviceID"],
        date: [moment().format("YYYY-MM-DD"),moment().subtract(1,'day').format("YYYY-MM-DD"),moment().subtract(2,'days').format("YYYY-MM-DD")],
      };
      this.history_chart(newparam);
    this.apiInterval = setTimeout(() => {
    //   if (this.intervalFlag === true) {
    //     this.getCustData(this.params);
    // // this.gattchart(this.params);
    // this.devicebarchart(this.params);

    //     // this.lossCount(this.params);
    // this.getPartCount(this.params);

    //   }
    this.toastr.info('Click the Refresh button to get live Data');
    }, 180000);
    this.dayarray();
  }

  refreshData() {
    this.liveBool = true;
    this.getCustData(this.params);
    // this.lossCount(this.params);
    this.gattchart(this.params);
    this.devicebarchart(this.params);
    this.getPartCount(this.params);
    this.scatterChart();
    this.hourlyPart(this.params);
    var newparam = {
      custID: this.params["custID"],
      deviceID: this.params["deviceID"],
      date: [moment().format("YYYY-MM-DD"),moment().subtract(1,'day').format("YYYY-MM-DD"),moment().subtract(2,'days').format("YYYY-MM-DD")],

    };
    this.history_chart(newparam);
  }

  getCustData(param: any) {
    if (param.shiftName) {
    } else {
      this.params.shiftName = this.currentShift?.usershiftId;
    }
    this.http.post(`https://k2-oee-prod.azurewebsites.net/api/device${this.liveBool ? '/live' : ''}?code=Sp9IPS7K50IVTzWN3jKJmCbZAcCUTJFicXz1ovZn_n4RAzFuk9ivSQ==`,
    param
      )
      .subscribe((res: any) => {
        this.current = res["current"] || 0;
        this.r_power = res["real_power"] || 0;
        this.a_power = res["apparent_power"] || 0;
        this.energy = res["energy_consumption"] || 0;
        this.t_energy = res["total_energy"] || 0;
        this.isReactivePower = res.hasOwnProperty("reactive_power");
        this.reactive_power = res["reactive_power"] || 0;
        // console.group(this.isReactivePower,this.reactive_power,'reactive_power')
        this.LUT = res["LUT"] || 0;
        this.m_effic = res["oee"] ? res["oee"].toFixed(1) : 0;
        this.perf = res["performance"] ? res["performance"].toFixed(1) : 0;
        this.totalPartCount = res['totalPartproduced'] ? res['totalPartproduced'] : 0;
        this.quality = res["quality"] ? res["quality"].toFixed(1) : 0;
        this.availability = res["availability"]
          ? res["availability"].toFixed(1)
          : 0;
        this.status = res["status"];
        this.count = res?.part_count || "-";
        this.powerUnitCost = res?.powerUnitCost || 0;
      },(error)=>{
        // console.log(error,'error1');
        this.toastr.error(error)
      });
  }

  lossCount(param: any) {
    delete this.params.shiftName;
    this.http
      .post(
        "https://k2-oee-prod.azurewebsites.net/api/prod_loss?code=EB7UcHbHBZ2PwKbhP-Clxp14bPqRpJpvxI4DW8CPmYCfAzFuSH3iMA==",
        param
      )
      .subscribe((res) => {
        this.prodLoss = res["total_prod_loss"];
        this.energycost = res["power_unit_cost"];
      },(error)=>{
        // console.log(error,'error2');
        this.toastr.error(error)
      });
  }

  tempTrend(data: any) {
    this.http
      .post(
        `https://k2-oee-prod.azurewebsites.net/api/device_energymeter_chart/${this.trendData}?code=UhMxKcwmajIIgrNQKaia-NO1e0eaoijznewFJm1dBgF5AzFuu3wwrw==`,
        data
      )
      .subscribe((res) => {
        this.trendChart = res;
        console.log(this.trendChart,"trendChart123")
      },(error)=>{
        // console.log(error,'error3');
        this.toastr.error(error)
      });
  }

  gattchart(param: any) {
    if (param.shiftName) {
    } else {
      this.params.shiftName = this.currentShift.usershiftId;
    }
    this.http
      .post(
        "https://k2-oee-prod.azurewebsites.net/api/device_gantt_chart?code=rTjgE3saT7l_LNXSmiBDlvt3C1_OFBm3as-HY9SeV1YDAzFu-8-HSg==",
        param
      )
      .subscribe((res) => {
        if (res["time"][0]?.length > 0) {
          this.finalcombinedData = res;
        }
      },(error)=>{
        // console.log(error,'error4');
        this.toastr.error(error)
      });
  }
showload=false
  devicebarchart(param) {
    this.historyDatas = [];
    this.showload=true
    this.showChart = false
    if (param.shiftName) {
    } else {
      this.params.shiftName = this.currentShift.usershiftId;
    }

    this.http
      .post(
        "https://k2-oee-prod.azurewebsites.net/api/device_bar_chart_testing?code=AoThSCnmA2IYtXSZY4y1U8zmAMw5qGmdfCX-KMgok7fNAzFuSeIoGw==",
        param
      )
      .subscribe(
        (res) => {
          this.historyDatas = [];
          this.device_bar_chart = res;
          console.log(this.device_bar_chart,"device_bar_chart")
          if (res.hasOwnProperty("chart_data")) {
            this.pieStatus = res["chart_data"];
            const outputData = this.pieStatus.map((item) => {
              var color;
              if (item.status === "dryrun") {
                color = "#ffff94";
              } else if (item.status === "running") {
                color = "#548237";
              } else if (item.status === "idle") {
                color = "#f7c030";
              } else if (item.status === "standby") {
                color = "#f54c4c";
              } else if (item.status === "off") {
                color = "#b0b0b0";
              } else if (item.status === "warning") {
                color = "#bfe0a5";
              } else if (item.status === "alarm") {
                color = "#ee4932";
              }
              return {
                value:
                  Math.sign(item.duration) == -1
                    ? Math.abs(item.duration)
                    : item.duration,
                name: item.status,
                percent: item.percent,
                itemStyle: {
                  color: color,
                },
              };
            });
            this.showPieChart = true;
            this.pie_response = outputData;
            this.donughnutChart = this.pieChart(outputData);
          }
          if (
            res.hasOwnProperty("overall_status") &&
            res["overall_status"].length
          ) {
            this.showChart = true;
            this.showload =false
            this.spinner.hide();

            this.historyDatas = res["overall_status"];
          }else{
            this.showChart = false;
            this.spinner.hide();
            this.showload =false
          }

        },
        (error) => {
          // console.log(error,'error5');
          this.showload =false
          this.spinner.hide();
          this.toastr.error(error)
          this.showChart = false;
        }
      );
  }

  pieChart(data: any) {
    // console.log(data, "data123")
    return {
      title: {
        text: "Machine Status Chart",
        left: "center",
        textStyle: {
          color: "#000",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          var value = params.value;
          var hours = Math.floor(value / 60);
          var minutes = Math.floor(value % 60);
          var seconds = Math.floor((value * 60) % 60);
          var formattedValue =
            hours.toString().padStart(2, "0") +
            ":" +
            minutes.toString().padStart(2, "0") +
            ":" +
            seconds.toString().padStart(2, "0");

          return `${params.seriesName}<br/>${(params.name)}: ${formattedValue} (${params.percent}%)`;
        },
      },
      legend: {
        bottom: '5%',
        left: 'center'
      },
      series: [
        {
          name: "Status",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center",
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            formatter: function (params) {
              // console.log(params, '123')
            }
          },
          itemStyle: {
            borderRadius: 5,
            borderColor: "rgba(0, 0, 0, 0.5)",
            borderWidth: 1,
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: data,
        },
      ],
    };
  }

  hourlyPart(param: any) {
    // console.log(param,"paramparamparam123")
    delete this.params.deviceType;
    // delete this.params.shiftName;
    this.showHourchart = false;
    if(param.custID){
      param={custId:param.custID,deviceId:param.deviceID,shiftName:param.shiftName}
    }
    // if (param.shiftName) {
    // } else {
    //   this.params.shiftName = this.currentShift.usershiftId;
    // }
    // console.log(param,"paramparamparam123")
    this.http
      .post(
        `https://k2-clustering-partcount.azurewebsites.net/api/hourlypartcount_chart?code=bsVaDxG6LC2UQxhuOpWMbnftu_FkKQo0Vmr5hxntvUNzAzFuQVVrDw==`,param
        // `https://k2dev.azurewebsites.net/api/getHourlyPartCountChart?custId=${param.custID}&deviceId=${param.deviceID}`
      )
      .subscribe((res) => {
        if (res["partcount"]?.length > 0) {
          this.showHourchart = true;
          this.hourlyData = res;
           this.totalHourlyPartCount = this.hourlyData.partcount.reduce((sum, count) => sum + count, 0);
        }
      },(error)=>{
        // console.log(error,'error4');
        this.toastr.error(error)
      });
  }

  dayarray() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const dayBeforeYesterday = new Date(today);
    dayBeforeYesterday.setDate(today.getDate() - 2);
    this.previousDays = [
      yesterday.toISOString().split("T")[0],
      dayBeforeYesterday.toISOString().split("T")[0],
    ];
  }

  getPartCountData(){
    if(this.parts>0){
      this.typeData='AI'
    }
    if(this.totalPartCount>0){
      this.typeData='Digital'
    }
  }

  LiveChart(param: any) {
    this.getPartCount(param);
    this.hourlyPart(param);
  }

  getPartCount(param: any) {
    if (param.shiftName) {
    } else {
      this.params.shiftName = this.currentShift.usershiftId;
    }
    this.dataservice.partCount(param).subscribe(
      (res) => {
        this.parts =
          res["partcount_Type"] == "AI" ? res["pattern_count"] : this.count;
        this.typeData = res["partcount_Type"];
      },
      (error) => {
        this.toastr.error(error)
        // console.error(error, "abcdef");
      }
    );
  }

  selectedShift($event: any) {
    this.selectedCars = $event;
    if (
      this.currentShift.usershiftId === this.selectedCars ||
      this.selectedCars === "All Shift"
    ) {
      this.intervalFlag = true;
    } else {
      this.intervalFlag = false;
    }
    if (this.selectedCars === "All Shift") {
      this.params.shiftName = "all";
    } else {
      this.params.shiftName = this.selectedCars;
    }
    this.showChart = false;
    this.showPieChart = false;
    this.spinner.show();
    this.getCustData(this.params);
  }

  onClick(data: any) {
    this.selectedTab = data;
    if (data == "Outline") {
      this.outLine = true;
      this.timeLine = false;
      this.partDetails = false;
    } else if (data == "TimeLines") {
      this.timeLine = true;
      this.partDetails = false;
      this.outLine = false;
      this.gattchart(this.params);
    } else if (data == "PartDetails") {
      this.partDetails = true;
      this.outLine = false;
      this.timeLine = false;
      this.getPartCount(this.params);
    }
  }

  toggleChart() {
    this.isLineChart = !this.isLineChart;
    if(!this.isLineChart){
    this.scatterChart();

    }
  }

  ngAfterViewInit() { }

  ngOnDestroy() {
    if (this.apiInterval) {
      clearTimeout(this.apiInterval);
    }
    this.toastr.clear();
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCurrentShift(shifts: any) {
    const currentTime = new Date();
    const currentTimeString = `${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}`;
    const statuses = [];
    for (const shift of shifts) {
      if (
        this.compareTimes(currentTimeString, shift.startTime) >= 0 &&
        this.compareTimes(currentTimeString, shift.endTime) <= 0
      ) {
        statuses.push({
          shiftName: shift.shiftName,
          status: "Running",
        });
      } else if (this.compareTimes(currentTimeString, shift.startTime) < 0) {
        statuses.push({
          shiftName: shift.shiftName,
          status: "Upcoming",
        });
      } else {
        statuses.push({
          shiftName: shift.shiftName,
          status: "Past",
        });
      }
    }
    return statuses;
  }

  compareTimes(time1: any, time2: any) {
    const [hours1, minutes1, seconds1] = time1.split(":").map(Number);
    const [hours2, minutes2, seconds2] = time2.split(":").map(Number);

    if (hours1 !== hours2) {
      return hours1 - hours2;
    } else if (minutes1 !== minutes2) {
      return minutes1 - minutes2;
    } else {
      return seconds1 - seconds2;
    }
  }

  // getCurrentShiftName(shifts: any) {

  //   const currentTime = new Date();
  //   const currentHour = currentTime.getHours();
  //   const currentMinute = currentTime.getMinutes();
  //   const currentSecond = currentTime.getSeconds();
  //   const currentSeconds =
  //     currentHour * 3600 + currentMinute * 60 + currentSecond;
  //   let startTime = moment(shifts[0].startTime, "HH:mm:ss").format("HH:mm:ss");
  //   let endTime = moment(shifts[0].endTime, "HH:mm:ss")
  //     .add(1, "seconds")
  //     .format("HH:mm:ss");
  //   if (shifts.length == 1 && startTime == endTime) {
  //     return shifts[0];
  //   } else {
  //     for (const shift of shifts) {
  //       let startSeconds = this.getSecondsFromString(shift.startTime);
  //       let endSeconds = this.getSecondsFromString(shift.endTime);

  //       if (shift.endNextDayFlag) {
  //         endSeconds += 24 * 3600;
  //       }
  //       if (currentSeconds >= startSeconds && currentSeconds <= endSeconds) {
  //         return shift;
  //       }
  //     }
  //   }

  //   return null;
  // }

  getSecondsFromString(timeString: any) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  epochToHHMMSS(epochTime: any) {
    // if (typeof epochTime === "undefined") {
    //   return "-";
    // }
    // const isMilliseconds = epochTime > 9999999999;
    // const date = new Date(isMilliseconds ? epochTime : epochTime * 1000);
    // const day = String(date.getDate()).padStart(2, "0");
    // const month = String(date.getMonth() + 1).padStart(2, "0");
    // const year = String(date.getFullYear()).slice(-2);
    // let hours = date.getHours();
    // const minutes = String(date.getMinutes()).padStart(2, "0");
    // const seconds = String(date.getSeconds()).padStart(2, "0");
    // const ampm = hours >= 12 ? "PM" : "AM";
    // hours = hours % 12;
    // hours = hours ? hours : 12;
    // const formattedHours = String(hours).padStart(2, "0");
    // return `${day}/${month}/${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
    return moment.tz(epochTime, this.timeZone).format("YYYY-MM-DD HH:mm:ss");
  }

  scatterChart() {
    // this.params.shiftName = "all";
    // this.isCollapsed = !this.isCollapsed;
    var param = this.params;
    this.clustr_Chart = false;
    delete this.params.deviceType;
    // if (this.isCollapsed === false) {
      this.cluster_data = [];
      this.http
        .post(
          "https://k2-oee-prod.azurewebsites.net/api/clustering?code=5tUM7VsH-ItvOhMXCvpooz3fI6q89JM5MD330WduP4FBAzFuZxzZAA==",
          param
        )
        .subscribe((res) => {
          if (Object.keys(res).length != 0 && res["clustering_data"].length) {
            this.clustr_Chart = true;
            this.cluster_data = res["clustering_data"];
          }else{
            this.clustr_Chart = false;
          }
        },(error)=>{
          this.toastr.error(error)
        });
    // }
  }

  secondsToHms(data: any) {
    data = Number(data);
    if (Math.sign(data) == -1) {
      data = Math.abs(data);
    }
    const hours = Math.floor(data / 60);
    const minutes = Math.floor(data % 60);
    const seconds = Math.round((data * 60) % 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  }

  houers(data: any) {
    let valueInHMS = "00:00:00";
    if (this.pie_response) {
      let existing = this.pie_response.find((item) => item.name == data);
      if (existing == undefined) {
        valueInHMS = "00:00:00";
      } else {
        valueInHMS = this.secondsToHms(existing.value);
      }
    }
    return valueInHMS;
  }

  backbtn(data: any) {
    if (this.role === "CUSTOMER") this.router.navigate(["/"]);
    else if (this.role === "SUPERADMIN") this.router.navigate(["/admin"]);
    else if (this.role === "SUPERVISOR") this.router.navigate(["/"]);
  }

  statusColor(data: any) {
    switch (data) {
      case 1: {
        this.currentStatus = "Running";
        return "#548237";
        break;
      }
      case 0: {
        this.currentStatus = "Idle";
        return "#f7c030";
        break;
      }
      case 2: {
        this.currentStatus = "StandBy";
        return "#f54c4c";
        break;
      }
      case 4: {
        this.currentStatus = "Off";
        return "#b0b0b0";
        break;
      }
    }
  }

  colorCode(data: any) {
    if (data === "dryrun") {
      return "#ffff94";
    } else if (data === "running") {
      return "#548237";
    } else if (data === "idle") {
      return "#f7c030";
    } else if (data === "standby") {
      return "#f54c4c";
    } else if (data === "off") {
      return "#b0b0b0";
    } else if (data === "warning") {
      return "#bfe0a5";
    } else if (data === "alarm") {
      return "#ee4932";
    }
  }

  // historyChart() {
  //   if (this.selectedDateOption == "Live") {
  //     this.historycombinedData = [];
  //     this.historydata = false;
  //     this.intervalFlag = true;
  //     this.gattchart(this.params);
  //     let param = {
  //       custID: this.params["custID"],
  //       deviceID: this.params["deviceID"],
  //       shiftName:this.currentShift.usershiftId,
  //       deviceType:this.params['deviceType']
  //     };
  //     this.devicebarchart(param)
  //     this.toastr.success("Live On, Please wait we are fetching record");
  //   } else {
  //     this.historycombinedData = [];
  //     var param = {
  //       custID: this.params["custID"],
  //       deviceID: this.params["deviceID"],
  //       date: this.selectedDateOption,
  //     };
  //     this.history_chart(param);

  //     this.toastr.warning("Live Off, Please wait we are fetching record");
  //     this.intervalFlag = false;
  //   }
  // }

  combined() {
    this.showCombined = !this.showCombined;
  }

  history_chart(param: any) {
    this.spinner.show();
    this.showload=true;
    this.showChart1 = false;
    this.historydata = false;
    this.currentDay = [];
    this.yesterDay=[];
    this.previousyesterDay=[];
    // this.dataservice.history_chart(param).subscribe(
    //   (res) => {
    //     var data = res;
    //     console.log(res)
    //     if (res) {
    //       this.showChart1 = true;
    //       this.historydata = true;
    //       this.showload=false;
    //       this.currentDay = res["overall_status1"];
    //       this.yesterDay = res["overall_status2"];
    //       this.previousyesterDay = res["overall_status3"];
    //       console.log(this.currentDay,this.yesterDay,this.previousyesterDay,"previousyesterDay")
    //       this.spinner.hide();
    //     }else{
    //       this.showChart1 = false;
    //       this.showload=false;
    //       this.spinner.hide();
    //     }
    //   },
    //   (error) => {
    //     this.spinner.hide();
    //     this.showChart1 = false;
    //     this.showload=false;
    //     // console.error(error, "abcdef");
    //     this.toastr.error(error)
    //   }
    // );
  }

  addSample(act: any) {
    this.router.navigate([
      "/recordsample",
      { mch: this.deviceName, view: act },
    ]);
  }

  getTitle(data: any) {
    return data ? data.charAt(0).toUpperCase() + data.slice(1).toLowerCase() : '';
  }

  openModal(infotemplate: any, parameter: any) {
    this.modalService.dismissAll();
    this.trendChart = [];
    this.trendData = parameter;
    if (this.trendData==='partData') {
      this.hourlyPart(this.params);

      setTimeout(() => {
        this.modalService.dismissAll();
          // if(this.trendChart?.time?.length>0)

          this.modalService.open(infotemplate, {
            backdrop: "static",
            centered: true,
            size: "xl",
          });
        }, 2000);
    }
    else if (this.trendData !== 'partData' && this.trendData !== 'pieChart')
    {

      this.tempTrend(this.params);
    setTimeout(() => {
    this.modalService.dismissAll();
      // if(this.trendChart?.time?.length>0)

      this.modalService.open(infotemplate, {
        backdrop: "static",
        centered: true,
        size: "xl",
      });
    }, 2000);
  }
    if(this.trendData === 'pieChart'){
      this.modalService.dismissAll();
      // if(this.trendChart?.time?.length>0)
      this.modalService.open(infotemplate, {
        backdrop: "static",
        centered: true,
        size: "md",
      });
    }
  }

  showDeviceInfo() { }
}
